import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import UserDetails from '../components/UserDetails';
import { useAuth } from '../hooks/useAuth';


const DetailsPage = () => {
  const { id } = useParams();
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();

  const API_URL = process.env.NODE_ENV === 'development' ? "http://172.20.116.87:6060": "/agent-backend";
  useEffect(() => {
    console.log("id",id)
    fetch(API_URL+'/api/task/'+id, {headers: { "Authorization": user.token }})  
    .then( response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Something went wrong');
    })  
    .then(resData => {
      console.log(resData) 
      setTask(resData)
      setLoading(false)

    })
    .catch(error => {
      console.log("error",error)
      setLoading(false)
      setError("no data");
    })

    // Simulate API call
    // setTimeout(() => {
    //   const foundUser = mockUsers.find(user => user.id === Number(id));
    //   if (foundUser) {
    //     setUser(foundUser);
    //   } else {
    //     setError('User not found');
    //   }
    //   setLoading(false);
    // }, 500);
  }, [id]);

  if (loading) {
    return <div>Loading details...</div>;
  }

  if (error) {
    return (
      <div className="card">
        <h2>{error}</h2>
        <Link to="/tasks/list" className="btn btn-primary">
           Back to Task List
        </Link>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Task Details</h1>
        <Link to="/tasks/list" className="btn btn-secondary">
          Back to Task List
        </Link>
      </div>
      <UserDetails task={task} />
    </div>
  );
};

export default DetailsPage;